module.exports = __webpack_public_path__ + "img/bg3.6a0ec8e6.png";